export default [
  {
    srno: "1",
    menuName: "Product Page",
    order: "1",
    subMenu:
      "In publishing and graphic design, Lorem ipsum is a placeholder text commonly.",
    pageurl: "d/User/FolderName/Doc.png	",
    tags: "#productpage	"
  },
  {
    srno: "2",
    menuName: "Product Page",
    order: "4",
    subMenu:
      "In publishing and graphic design, Lorem ipsum is a placeholder text commonly.",
    pageurl: "d/User/FolderName/Doc.png	",
    tags: "#productpage	"
  },
  {
    srno: "3",
    menuName: "Product Page",
    order: "2",
    subMenu:
      "In publishing and graphic design, Lorem ipsum is a placeholder text commonly.",
    pageurl: "d/User/FolderName/Doc.png	",
    tags: "#productpage	"
  },
  {
    srno: "4",
    menuName: "Product Page",
    order: "3",
    subMenu:
      "In publishing and graphic design, Lorem ipsum is a placeholder text commonly.",
    pageurl: "d/User/FolderName/Doc.png	",
    tags: "#productpage	"
  }
];
